import axios from 'axios'

var BrowserDetect = {
    init: function () {
        this.browser = this.searchString(this.dataBrowser) || "Other";
        this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "Unknown";
    },
    searchString: function (data) {
        for (var i = 0; i < data.length; i++) {
            var dataString = data[i].string;
            this.versionSearchString = data[i].subString;

            if (dataString.indexOf(data[i].subString) !== -1) {
                return data[i].identity;
            }
        }
    },
    searchVersion: function (dataString) {
        var index = dataString.indexOf(this.versionSearchString);
        if (index === -1) {
            return;
        }

        var rv = dataString.indexOf("rv:");
        if (this.versionSearchString === "Trident" && rv !== -1) {
            return parseFloat(dataString.substring(rv + 3));
        } else {
            return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
        }
    },

    dataBrowser: [
        {string: navigator.userAgent, subString: "Edge", identity: "MS Edge"},
        {string: navigator.userAgent, subString: "MSIE", identity: "Explorer"},
        {string: navigator.userAgent, subString: "Trident", identity: "Explorer"},
        {string: navigator.userAgent, subString: "Firefox", identity: "Firefox"},
        {string: navigator.userAgent, subString: "Opera", identity: "Opera"},
        {string: navigator.userAgent, subString: "OPR", identity: "Opera"},
        {string: navigator.userAgent, subString: "Chrome", identity: "Chrome"},
        {string: navigator.userAgent, subString: "Chromium", identity: "Chromium"},
        {string: navigator.userAgent, subString: "Safari", identity: "Safari"}
    ]
};

BrowserDetect.init();


let portrait = window.matchMedia("(orientation: landscape)");
portrait.addEventListener("change", checkDeviceOrientation)

function checkDeviceOrientation(e){
    if(e.matches) {
        // Landscape mode
        $('#checkdeviceorientation').removeClass('show');

    } else {
        // Portrait mode
        $('#checkdeviceorientation').addClass('show');

    }
}

/**
 * Dropdown toggle
 */
$('.dropdown').click(function(){
    let className = 'show',
     isOpen = $(this).hasClass(className);

    if(isOpen) {
        $(this).removeClass(className);
        $(this).find('.dropdown-menu').removeClass(className);
    } else {
        $(this).addClass(className);
        $(this).find('.dropdown-menu').addClass(className);
    }
});


// Supported browsers
const supportedBrowsers = [ 'Chrome' , 'Firefox' , 'MS Edge', 'Chromium'];
// If browser is not supported, show popup to download Chrome
// if (supportedBrowsers.indexOf(BrowserDetect.browser) !== -1){
//     $('#checkbrowser').removeClass('show');
// } else {
//     $('#checkbrowser').addClass('show');
// }
//
// //Check Mobile Devices
// var checkMobile = function(){
//     //Check Device
//     var isTouch = ('ontouchstart' in document.documentElement);
//     //Check Device //All Touch Devices
//     if ( isTouch ) {
//         $('#checktouchdevice').addClass('show');
//     }
//     else {
//         $('#checktouchdevice').removeClass('show');
//     }
// };
//
// //Execute Check
// checkMobile();
